import { OrAsync } from '@examdojo/core/typescript';
import { from, isObservable } from 'rxjs';

export const ensureObservable = <T>(orAsync: OrAsync<T>) =>
  isObservable(orAsync) ? orAsync : from(Promise.resolve(orAsync));
